<template>
  <v-container fluid class="job-posting-list">
    <v-row class="ma-0">
      <v-col class="pa-0">
        <v-card
          class="mx-auto pa-0"
          width="960"
          elevation="0"
          style="background-color:#f2f2f2"
        >
          <!-- only PC -->
          <v-row class="ma-0 mb-4 main-title d-none d-md-flex">{{
            $t('채용공고')
          }}</v-row>
          <v-row
            class="ma-0 d-none d-md-flex"
            align="center"
            justify="space-between"
          >
            <v-col cols="" class="search-box pa-0 mr-8">
              <i-text-field
                label="공고 검색"
                v-model="searchWord"
                @keyup.enter="getAnnouncements(1)"
                outlined
                dense
                hide-details
              ></i-text-field>
              <button
                type="button"
                class="search-btn"
                @click="getAnnouncements(1)"
              >
                {{ $t('검색') }}
              </button>
            </v-col>
            <v-col cols="auto" class="pa-0">
              <i-checkbox
                v-model="includeFinAnno"
                dense
                hide-details
                label="마감된 공고 포함"
                class="icon-checkbox"
              ></i-checkbox>
            </v-col>
          </v-row>
          <v-card
            class="mt-4 d-none d-md-block"
            elevation="10"
            v-if="announces"
          >
            <v-row
              v-for="(announce, idx) in announces"
              class="ma-0 px-8 py-5 bd-B-1px"
              align="center"
              :key="'announce' + idx"
              @click="goDetail(announce.annoId)"
            >
              <v-col
                cols="auto"
                class="pa-0 mr-8"
                :class="{
                  'icon-deadline': announce.status == 'FIN',
                  'icon-recruitment': announce.status != 'FIN',
                }"
              >
                <template v-if="announce.status == 'FIN'">
                  {{ $t('마감') }}
                </template>
                <template v-else>
                  {{ $t('모집중') }}
                </template>
              </v-col>
              <v-col cols="" class="pa-0 list-title">
                {{ announce.title }}
              </v-col>
              <v-col cols="auto" class="pa-0 ml-10 term">
                {{ announce.term }}
              </v-col>
            </v-row>
          </v-card>
          <!-- start : only mobile & tablet -->
          <v-row class="pl-6 ma-0 mb-4 main-title d-sm-block d-md-none">{{
            $t('채용공고')
          }}</v-row>
          <v-row
            class="px-6 ma-0 d-sm-block d-md-none"
            align="center"
            justify="space-between"
          >
            <v-col cols="12" class="search-box pa-0">
              <i-text-field
                label="공고 검색"
                v-model="searchWord"
                @keyup.enter="getAnnouncements(1)"
                outlined
                dense
                hide-details
              ></i-text-field>
              <button
                type="button"
                class="search-btn"
                @click="getAnnouncements(1)"
              >
                {{ $t('검색') }}
              </button>
            </v-col>
            <v-col cols="12" class="pa-0">
              <i-checkbox
                v-model="includeFinAnno"
                dense
                hide-details
                label="마감된 공고 포함"
                class="icon-checkbox"
              ></i-checkbox>
            </v-col>
          </v-row>
          <v-card
            class="mt-4 d-sm-block d-md-none"
            elevation="10"
            v-if="announces"
          >
            <v-row
              v-for="(announce, idx) in announces"
              class="ma-0 px-6 py-5 bd-B-1px"
              align="center"
              :key="'announce' + idx"
              @click="goDetail(announce.annoId)"
            >
              <v-col
                cols="auto"
                class="pa-0 mr-8"
                :class="{
                  'icon-deadline': announce.status == 'FIN',
                  'icon-recruitment': announce.status != 'FIN',
                }"
              >
                <template v-if="announce.status == 'FIN'">
                  {{ $t('마감') }}
                </template>
                <template v-else>
                  {{ $t('모집중') }}
                </template>
              </v-col>
              <v-col cols="" class="pa-0">
                <div class="list-title">{{ announce.title }}</div>
                <div class="term">{{ announce.term }}</div>
              </v-col>
            </v-row>
          </v-card>
          <!-- end : only mobile & tablet -->
          <v-row
            class="ma-0"
            justify="center"
            v-if="announces && announces.length > 0"
          >
            <v-pagination
              v-model="page"
              :length="totalSize"
              @input="getAnnouncements"
              class="paging-wrap"
            ></v-pagination
          ></v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { getJson } from '@/api/network';
import { LoadingMixin } from '@/mixin/loading.js';

export default {
  mixins: [LoadingMixin],
  data() {
    return {
      announces: [],
      searchWord: '',
      page: 1,
      totalSize: 1,
      includeFinAnno: false,
    };
  },
  watch: {
    includeFinAnno() {
      this.getAnnouncements(1);
    },
  },
  mounted() {
    this.getAnnouncements(1);
  },
  methods: {
    getAnnouncements(page) {
      this.page = page;
      this.showLoading();
      const p = {
        searchWord: this.searchWord,
        includeFinAnno: this.includeFinAnno ? 'Y' : 'N',
        page: this.page,
      };
      getJson('api/' + this.$route.params.tenantKey + '/announce/list', p).then(
        res => {
          if (res.status == 200) {
            this.announces = res.data.rows;
            this.totalSize = res.data.total;
          } else {
            this.announces = [];
            this.totalSize = 1;
          }
          this.hideLoading();
        },
      );
    },
    goDetail(annoId) {
      this.$router.push({
        name: 'jobPostingDetail',
        params: { tenantKey: this.$route.params.tenantKey, annoId: annoId },
      });
    },
  },
};
</script>
<style>
.job-posting-list {
  padding: 32px 0 70px 0;
  background-color: #f2f2f2;
  height: 100%;
}

.job-posting-list .main-title {
  font-size: 20px;
  font-weight: 700;
  color: #363c43;
}

.job-posting-list .icon-deadline {
  width: 56px;
  height: 56px;
  font-size: 12px;
  font-weight: 700;
  line-height: 54px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #465166;
  border-radius: 50%;
  box-sizing: border-box;
  color: #465166;
}

.job-posting-list .icon-recruitment {
  width: 56px;
  height: 56px;
  font-size: 12px;
  font-weight: 700;
  line-height: 54px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #087ef7;
  border-radius: 50%;
  box-sizing: border-box;
  color: #087ef7;
}

.job-posting-list .list-title {
  font-size: 18px;
  font-weight: 700;
  color: #363c43;
  cursor: pointer;
}

.job-posting-list .term {
  font-size: 15px;
  font-weight: 500;
  color: #777e87;
}

.job-posting-list .v-pagination__item {
  background-color: transparent !important;
}

.bd-A-1px {
  border: 1px solid #d5d8dc;
}

.bd-B-1px {
  border-bottom: 1px solid #d5d8dc;
}

.search-box {
  position: relative !important;
}

.search-box .search-btn {
  position: absolute;
  right: 0;
  top: 0;
  width: 80px;
  height: 38px;
  font-size: 14px;
  letter-spacing: -0.42px;
  background-color: #087ef7;
  border-radius: 0 6px 6px 0;
  color: #fff;
}

.search-box .v-input__slot {
  min-height: 38px !important;
  background-color: #fff !important;
}

.search-box fieldset {
  border: 1px solid #d5d8dc !important;
}

.search-box .v-input__slot .v-label {
  top: 8px !important;
  font-size: 14px !important;
  color: #cacdcf !important;
}

.search-box .v-input__slot input {
  font-size: 14px !important;
  color: #363c43 !important;
}

.search-box .v-text-field__details {
  display: none !important;
}

.icon-checkbox {
  margin: 0 !important;
  padding: 0 !important;
}

.icon-checkbox .v-icon__svg {
  width: 18px;
  height: 18px;
}

.icon-checkbox .v-input--selection-controls__input {
  margin-right: 0 !important;
}

.icon-checkbox .v-input__slot {
  min-height: auto !important;
}

.icon-checkbox .v-label {
  font-size: 14px !important;
  white-space: nowrap !important;
  color: #363c43 !important;
}

.paging-wrap {
  margin-top: 24px !important;
}

.paging-wrap .v-pagination__navigation {
  width: 26px !important;
  height: 26px !important;
  margin: 0 !important;
  border: 1px solid #d5d8dc !important;
  box-shadow: none !important;
}

.paging-wrap .v-pagination__navigation .v-icon__svg {
  width: 18px !important;
  height: 18px !important;
  color: #363c43 !important;
}

.paging-wrap .v-pagination__item {
  min-width: auto !important;
  height: 26px !important;
  padding: 0 7.5px !important;
  margin: 0 !important;
  font-size: 13px !important;
  box-shadow: none !important;
  color: #9ca3ab !important;
}

.paging-wrap .v-pagination__item.v-pagination__item--active {
  font-weight: 700 !important;
  background-color: transparent !important;
  color: #363c43 !important;
}
</style>
